export default __webpack_public_path__ + "4bf923a34f7b0f6f146cb60efe8472fa.svg";